/** Parses a RichTextLabel: Control plus text, layout and BBCode flags. */
import { unquoteString } from '../../../../parser/utils';
import { parseOptionalInt } from '../../../../parser/valueParsers';
import { parseControl } from '../control/parser';
import { boolSlotValue } from '../../../../godot/variant/variantBool.js';
import { packedArrayBody, packedArrayForms } from '../../../../godot/variant/variantParser.js';
import { floatElements } from '../../../../resources/shapes/packedArray';
const PACKED_FLOAT32_ARRAY_FORMS = packedArrayForms('PackedFloat32Array');
/** `RichTextLabel.tab_stops` from a flat `PackedFloat32Array(...)` literal, else undefined, as Label does. */
function parseTabStops(value) {
    if (value === undefined)
        return undefined;
    const matched = packedArrayBody(PACKED_FLOAT32_ARRAY_FORMS, value);
    if (!matched || matched.body === '')
        return undefined;
    try {
        return matched.flat ? floatElements(matched.body, 'PackedFloat32Array', value) : undefined;
    }
    catch {
        return undefined;
    }
}
export function parseRichTextLabel(heading, properties) {
    const result = { ...parseControl(heading, properties) };
    if (properties.text !== undefined)
        result.text = unquoteString(properties.text);
    result.bbcodeEnabled = boolSlotValue(properties.bbcode_enabled) === true;
    result.fitContent = boolSlotValue(properties.fit_content) === true;
    result.autowrapMode = parseOptionalInt(properties.autowrap_mode);
    result.horizontalAlignment = parseOptionalInt(properties.horizontal_alignment);
    result.verticalAlignment = parseOptionalInt(properties.vertical_alignment);
    result.tabStopsPx = parseTabStops(properties.tab_stops);
    result.tabSize = parseOptionalInt(properties.tab_size);
    result.autowrapTrimFlags = parseOptionalInt(properties.autowrap_trim_flags, 'int64');
    return result;
}
//# sourceMappingURL=parser.js.map